import { get, post } from "../api/apiClient";
import { authHeader } from "../api/authHeader";
import StudentCreateRequest from "../form/request/StudentCreateRequest";
import StudentUpdateRequest from "../form/request/StudentUpdateRequest";
import StudentStopRequest from "../form/request/StudentStopRequest";
import StudentSelfEvaluationCheckRequest from "../form/request/StudentSelfEvaluationCheckRequest";

const API_PREFIX = "/student";

export const create = async request => {
  const response = await post(`${API_PREFIX}/create`, new StudentCreateRequest(request), authHeader());
  console.log("response", response);
  return response.data;
};

export const uploadFile = async request => {
  const response = await post(`${API_PREFIX}/uploadFile`, request, authHeader());
  console.log("response", response);
  return response.data;
};

export const search = async request => {
  console.log("request", request);
  var requestUrl =
    "?serialNumber=" +
    request.serialNumber +
    "&grade=" +
    request.grade +
    "&classNumber=" +
    request.class +
    "&number=" +
    request.number +
    "&name=" +
    request.name +
    "&endDateFlg=" +
    request.endDateFlg;
  const response = await get(`${API_PREFIX}/search${requestUrl}`, authHeader());
  console.log("response", response);
  return response.data;
};

export const update = async request => {
  console.log("request", request);
  const response = await post(`${API_PREFIX}/update`, new StudentUpdateRequest(request), authHeader());
  console.log("response", response);
  return response.data;
};

export const stop = async request => {
  console.log("request", request);
  const response = await post(`${API_PREFIX}/stop`, new StudentStopRequest(request), authHeader());
  console.log("response", response);
  return response.data;
};

export const initMenu = async () => {
  const response = await get(`${API_PREFIX}/initMenu`, authHeader());
  console.log("response", response);
  return response.data;
};

export const checkEvaluation = async request => {
  const response = await post(
    `${API_PREFIX}/checkEvaluation`,
    new StudentSelfEvaluationCheckRequest(request),
    authHeader()
  );
  console.log("response", response);
  return response.data;
};

export const sampleExcelDownload = async () => {
  const response = await get(`${API_PREFIX}/generate`, authHeader());
  console.log("response", response);
  return response.data;
};
